import { render, staticRenderFns } from "./Emblemas.vue?vue&type=template&id=c4443778&scoped=true&"
import script from "./Emblemas.vue?vue&type=script&lang=js&"
export * from "./Emblemas.vue?vue&type=script&lang=js&"
import style0 from "./Emblemas.vue?vue&type=style&index=0&id=c4443778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4443778",
  null
  
)

export default component.exports